const isElementVisible = (element: Element): boolean => {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  if (element.hidden) {
    return false;
  }

  const { display, visibility } = element.style;
  if (display === 'none' || visibility === 'hidden') {
    return false;
  }

  const computed = window.getComputedStyle(element);
  return computed.display !== 'none' && computed.visibility !== 'hidden';
};

/**
 * True when an Ant Design Drawer or Modal is open in the document.
 * Ignores Select, DatePicker, Dropdown, Popover, and Tooltip portals.
 */
export const isAntdOverlayOpen = (root: ParentNode = document): boolean => {
  const openDrawer = root.querySelector('.ant-drawer.ant-drawer-open');
  if (openDrawer) {
    return true;
  }

  const modalWraps = root.querySelectorAll('.ant-modal-wrap');
  for (let index = 0; index < modalWraps.length; index += 1) {
    const wrap = modalWraps[index];
    if (isElementVisible(wrap)) {
      return true;
    }
  }

  return false;
};
